import React, { useState, useEffect, useRef } from "react";
import { getFooterLinks } from "../../../../Utils/generic";
import packageJson from '../../../../../package.json';

import {ExternalLinkIframe} from "../ExternalLinkIframe/index";
import useMedia from "use-media";

interface IFooter{
    shouldHide:boolean,
    showOnlyVersion?: boolean
}

interface IFooterList{
    key: string,
    value:string
}

export default ({ shouldHide,showOnlyVersion }:IFooter) => {
  const [sourceID, setSourceID] = useState("");
  const [showModalWithIframe, setShowModalWithIframe] = useState(false);
  
  const modalIframeSrc = useRef({
    url:"",header:""
  });
  
  const onLinkClick = (externalUrl:string) => {
    modalIframeSrc.current = {
      url: externalUrl,
      header: ""
    };
    setShowModalWithIframe(true);
  }

  const hideExternalIframe = () => {
    setShowModalWithIframe(false);
  }

  const renderLinks = (footerLists:IFooterList[], onLinkClick: (e:string)=> void) =>
    Object.entries(footerLists).map(([index, item]) => (
      <a
        style={{ marginRight: "10px", color: "#7d7d7d", cursor: "pointer" }}
        rel="noopener noreferrer"
        key={index}
        onClick={() => onLinkClick(item.value)}
      >
        {item.key}
      </a>
    ));
  return shouldHide ? (
    <div style={{ display: "none" }} />
  ) : (
    <div className={!showOnlyVersion?"page-footer":""}
      style={{
        display: "flex",
        color: "#000",
        width: showOnlyVersion? "100%": "94%",
        fontSize: 14,
        flexDirection: "row-reverse",
        zIndex: 20,
        backgroundColor:"#fff",
        flex: "0 0 auto",
        paddingBottom: "0.5rem",
        paddingTop: "0.5rem",
        margin:"0 auto",
        justifyContent: showOnlyVersion? "": "center"
      }}
    >
      {showOnlyVersion && <div style={{ marginRight: "20px", color: "#7d7d7d" }}>
        {`v${packageJson.version}`}
      </div>}
      {!showOnlyVersion && <div style={{ marginRight: "10px", color: "#7d7d7d" }}>
        {renderLinks(getFooterLinks(sourceID), onLinkClick)}
      </div>}
      <ExternalLinkIframe 
        showModalWithIframe={showModalWithIframe} 
        onExitClicked={hideExternalIframe} 
        modalIframeSrc={modalIframeSrc}
      /> 
    </div>
  );
};
